// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"7af6a056","457":"a31a7c96","522":"39c935e5","551":"f08f88f6","640":"11126420","736":"d8c448a4","828":"89358f49"}[chunkId] + ".chunk.js";
};